(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ghm-medical-trust-styles"] && !Shopify.designMode) return;
  try {
    const repairHomepageArticleLinks = () => {
  const replacements = [
    {
      previewKey: 'badae90067bd22d2ab06cfd7a8c0b71b',
      target: '/blogs/news/sonoeye-handheld-ultrasound-in-plastic-surgery'
    },
    {
      previewKey: '6603b4e2039e14a7930d2de82b425e63',
      target: '/blogs/news/advantages-of-mobile-handheld-ultrasound-devices-for-point-of-care-ultrasound'
    },
    {
      previewKey: 'd752d42a5c8d3f51cf0832034f3c6169',
      target: '/blogs/news/ultrasound-diagnosis-of-medullary-sponge-kidneys'
    }
  ];

  document.querySelectorAll('a[href*="shopifypreview.com/blogs/news/articles"]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    const replacement = replacements.find((item) => href.includes(item.previewKey));

    if (replacement) {
      link.setAttribute('href', replacement.target);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', repairHomepageArticleLinks, { once: true });
} else {
  repairHomepageArticleLinks();
}
  } catch(e) { console.error(e); }
})();

})();
